<template>
   <ul v-if="users?.length" class="__list">
      <li v-for="item in users">
         <UserCard
            :email="item.user_email"
            :image="getFileUrlFromBucket(item.user_propic_url)"
            :role="item.role"
            @click="() => toggleModal(item.user_id || undefined)"
         />
      </li>
   </ul>

   <NoData v-else :text="$t('info.no-users')" />

   <OrganizationUsersModal v-model="modalOpen" size="lg" :user-id="selectedId" />
</template>

<script lang="ts" setup>
import type { Unpacked } from '@xleddyl/types'
import { getFileUrlFromBucket } from '~/composables/api/helpers/get-file-url'
import type { useOrganization } from '~/composables/api/queries/organization'

type Props = {
   users?: Unpacked<
      NonNullable<ReturnType<typeof useOrganization>['data']['value']>
   >['user_organization']
}

const props = withDefaults(defineProps<Props>(), {})

const rbac = useRbac()

const modalOpen = ref<boolean>(false)
const selectedId = ref<string>()

const toggleModal = (id?: string) => {
   selectedId.value = id
   modalOpen.value = !modalOpen.value
}

defineExpose({
   action: () => toggleModal(),
   loading: false,
   disabled: !rbac(['organization:users:create']),
})
</script>
